define('replay/materials',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = {
        wingsuit: function () {
            return new THREE.MeshLambertMaterial({ color: 0x6f00ff });
        },
        velocityArrow: function () {
            return new THREE.MeshLambertMaterial({ color: 0x6f00ff });
        },
        velocityLine: function () {
            return new THREE.MeshBasicMaterial({ color: 0x6f00ff });
        },
        north: function () {
            return new THREE.MeshBasicMaterial({ color: 0x111111 });
        },
        backgroundCubeMap: function () {
            return new THREE.CubeTextureLoader().load([
                "/assets/images/3d/halfdome/right.jpg",
                "/assets/images/3d/halfdome/left.jpg",
                "/assets/images/3d/halfdome/top.jpg",
                "/assets/images/3d/halfdome/bottom.jpg",
                "/assets/images/3d/halfdome/front.jpg",
                "/assets/images/3d/halfdome/back.jpg"
            ]);
        }
    };
});
//# sourceMappingURL=/assets/javascripts/replay/materials.js.map;
